var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader",class:[`bg-${_vm.color}`]},[_c('img',{staticClass:"preloader__icon h-24 w-24",attrs:{"src":require("@/assets/images/brand/logo.svg")}}),_c('p',{staticClass:"loading"},[_vm._v(_vm._s(_vm.$t('dashboard.loading')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }